import { createSlice } from "@reduxjs/toolkit";



export const shoppingSlice = createSlice({
  name : 'shopping',
  initialState : null,
  reducers : {
    
  }
})

export const getItemData = ()=>(dispatch)=>{

} 


export const{} = shoppingSlice.actions;
export default shoppingSlice.reducer